import {ChangeDetectionStrategy, Component, Input, OnInit} from '@angular/core';
import {DbActiveModal} from "../../../modules/modal/modal-ref";
import * as fromStore from '../../../store';
import {Store} from "@ngrx/store";

@Component({
    selector: 'db-dedicated-vm-contact',
    templateUrl: './dedicated-vm-contact.component.html',
    styleUrls: ['./dedicated-vm-contact.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class DedicatedVmContactComponent implements OnInit {

  @Input() zoneIssue: boolean;
  constructor(
    private readonly _store: Store<fromStore.DbStoreState>,
    private readonly activeModal: DbActiveModal,
  ) {
  }

  ngOnInit() {
  }

  close() {
    this.activeModal.close();
  }

  public openChat() {
    this.close();
    if ((localStorage.getItem('dbVMChatMessageSent') === null)) {
      window['Smooch']?.createConversation({
        messages: [
          {
            text: 'I want to upgrade my VM resources',
            type: 'text',
            metadata: {
              ecommerce: true,
            }
          }
        ]
      }).then(() => {
        window['Smooch']?.open();
      });
      localStorage.setItem('dbVMChatMessageSent', '1');
    } else {
      window['Smooch']?.open();
    }
    this._store.dispatch(new fromStore.ToggleChatOverlay(false));
  }

  openIssueChat() {
      this.close();
      window['Smooch']?.open();
      this._store.dispatch(new fromStore.ToggleChatOverlay(false));
  }
}
